import { Typography } from '../../../../core/components/molecules/Typography';

interface IHeaderRevision {
  title: string;
  text: string;
}

const HeaderRevision: React.FC<IHeaderRevision> = ({ title, text }) => {
  return (
    <div className='flex flex-col gap-xs'>
      <Typography size='h2' type='title'>
        {title}
      </Typography>
      <Typography size='small'>{text}</Typography>
    </div>
  );
};

export default HeaderRevision;
